export default function () {
    const className = 'o-accordion';
    const openClass = className + '__item--open';

    const selector = '.' + className;

    let accordions = document.querySelectorAll(selector)
    if(accordions === null) return;

    accordions.forEach(a => {
        const items = a.querySelectorAll(selector + '__item');
        const triggers = a.querySelectorAll(selector + '__trigger');

        triggers.forEach((trigger, idx) => {
            let item = trigger.parentElement;

            trigger.onclick = () => {
                let expanded = trigger.getAttribute('aria-expanded') === 'true';
                expanded ? closeItem(item, trigger) : openItem(triggers, items, item, trigger)
            }
        })
    })

    function closeItem(item, trigger) {
        trigger.setAttribute('aria-expanded', 'false')
        item.classList.remove(openClass)
    }

    function openItem(triggers, items, item, currTrigger ) {
        closeAllExpandedItems(items, triggers)
        currTrigger.setAttribute('aria-expanded', 'true')
        item.classList.add(openClass)
    }

    function closeAllExpandedItems(items, triggers) {
        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'))
        items.forEach(i => i.classList.remove(openClass))
    }
}